import { Container } from '../styled'

export default function NotFound() {
  return <Container>404</Container>
}
